@if(loadingData==false){
<div>
  <h5>{{ "CREATE_USER.CREATE_USER" | translate }}</h5>
  <div class="card">
    <form [formGroup]="createUserForm" (ngSubmit)="createUser()" novalidate="">
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4 !p-4">
        <label class="form-label" for="userName"
          >{{ "CREATE_USER.USERNAME" | translate }}:</label
        >
        <div class="">
          <input
            class="form-control"
            [pSize]="'large'"
            pInputText
            [fluid]="true"
            type="text"
            formControlName="userName"
            [placeholder]="'CREATE_USER.USERNAME' | translate"
            autoComplete="userName"
            [ngClass]="{
              'is-invalid': createUserForm.controls['userName'].invalid,
              'is-valid': createUserForm.controls['userName'].valid
            }"
          />
          <ng-container
            [ngTemplateOutlet]="formError"
            [ngTemplateOutletContext]="{
              validation: 'required',
              message: 'MANAGE_USERS.USERNAME_REQUIRED' | translate,
              control: createUserForm.controls['userName']
            }"
          >
          </ng-container>
          <ng-container
            [ngTemplateOutlet]="formError"
            [ngTemplateOutletContext]="{
              validation: 'minlength',
              message: 'MANAGE_USERS.USERNAME_MIN' | translate,
              control: createUserForm.controls['userName']
            }"
          >
          </ng-container>
          <ng-container
            [ngTemplateOutlet]="formError"
            [ngTemplateOutletContext]="{
              validation: 'maxLength',
              message: 'MANAGE_USERS.USERNAME_MAX' | translate,
              control: createUserForm.controls['userName']
            }"
          >
          </ng-container>
        </div>
        <label class="form-label" for="email"
          >{{ "CREATE_USER.EMAIL" | translate }}:</label
        >
        <div class="">
          <input
            class="form-control"
            [pSize]="'large'"
            pInputText
            [fluid]="true"
            type="email"
            id="email"
            formControlName="email"
            [placeholder]="'CREATE_USER.EMAIL' | translate"
            autoComplete="email"
            [ngClass]="{
              'is-invalid': createUserForm.controls['email'].invalid,
              'is-valid': createUserForm.controls['email'].valid
            }"
          />
          <ng-container
            [ngTemplateOutlet]="formError"
            [ngTemplateOutletContext]="{
              validation: 'required',
              message: 'MANAGE_USERS.EMAIL_REQUIRED' | translate,
              control: createUserForm.controls['email']
            }"
          >
          </ng-container>
          <ng-container
            [ngTemplateOutlet]="formError"
            [ngTemplateOutletContext]="{
              validation: 'minlength',
              message: 'MANAGE_USERS.EMAIL_MIN' | translate,
              control: createUserForm.controls['email']
            }"
          >
          </ng-container>
          <ng-container
            [ngTemplateOutlet]="formError"
            [ngTemplateOutletContext]="{
              validation: 'maxLength',
              message: 'MANAGE_USERS.EMAIL_MAX' | translate,
              control: createUserForm.controls['email']
            }"
          >
          </ng-container>
        </div>
        <label class="form-label" for="firstName"
          >{{ "CREATE_USER.FIRSTNAME" | translate }}:</label
        >
        <div>
          <input
            class="form-control"
            [pSize]="'large'"
            pInputText
            [fluid]="true"
            type="text"
            id="firstName"
            formControlName="firstName"
            [placeholder]="'CREATE_USER.FIRSTNAME' | translate"
            autoComplete="firstName"
            [ngClass]="{
              'is-invalid': createUserForm.controls['firstName'].invalid,
              'is-valid': createUserForm.controls['firstName'].valid
            }"
          />
          <ng-container
            [ngTemplateOutlet]="formError"
            [ngTemplateOutletContext]="{
              validation: 'required',
              message: 'MANAGE_USERS.FIRSTNAME_REQUIRED' | translate,
              control: createUserForm.controls['firstName']
            }"
          >
          </ng-container>
          <ng-container
            [ngTemplateOutlet]="formError"
            [ngTemplateOutletContext]="{
              validation: 'minlength',
              message: 'MANAGE_USERS.FIRSTNAME_MIN' | translate,
              control: createUserForm.controls['firstName']
            }"
          >
          </ng-container>
          <ng-container
            [ngTemplateOutlet]="formError"
            [ngTemplateOutletContext]="{
              validation: 'maxLength',
              message: 'MANAGE_USERS.FIRSTNAME_MAX' | translate,
              control: createUserForm.controls['firstName']
            }"
          >
          </ng-container>
        </div>
        <label class="form-label" for="lastName"
          >{{ "CREATE_USER.LASTNAME" | translate }}:</label
        >
        <div class="">
          <input
            class="form-control"
            [pSize]="'large'"
            pInputText
            [fluid]="true"
            type="text"
            id="lastName"
            formControlName="lastName"
            [placeholder]="'CREATE_USER.LASTNAME' | translate"
            autoComplete="lastName"
            [ngClass]="{
              'is-invalid': createUserForm.controls['lastName'].invalid,
              'is-valid': createUserForm.controls['lastName'].valid
            }"
          />
          <ng-container
            [ngTemplateOutlet]="formError"
            [ngTemplateOutletContext]="{
              validation: 'required',
              message: 'MANAGE_USERS.LASTNAME_REQUIRED' | translate,
              control: createUserForm.controls['lastName']
            }"
          >
          </ng-container>
          <ng-container
            [ngTemplateOutlet]="formError"
            [ngTemplateOutletContext]="{
              validation: 'minlength',
              message: 'MANAGE_USERS.LASTNAME_MIN' | translate,
              control: createUserForm.controls['lastName']
            }"
          >
          </ng-container>
          <ng-container
            [ngTemplateOutlet]="formError"
            [ngTemplateOutletContext]="{
              validation: 'maxLength',
              message: 'MANAGE_USERS.LASTNAME_MAX' | translate,
              control: createUserForm.controls['lastName']
            }"
          >
          </ng-container>
        </div>
        <label class="form-label" for="roleId"
          >{{ "CREATE_USER.ROLE" | translate }}:</label
        >
        <div class="">
          @if(rolesOptions$| async; as roles){
          <p-select
            formControlName="role"
            [size]="'large'"
            [options]="roles"
            [fluid]="true"
            class="form-select form-select-solid form-select-lg font-semibold"
            id="role"
          />
          }
        </div>
        <label class="form-label" for="password"
          >{{ "CREATE_USER.PASSWORD" | translate }}:</label
        >
        <div class="">
          <input
            class="form-control"
            [pSize]="'large'"
            pInputText
            [fluid]="true"
            type="password"
            id="password"
            formControlName="password"
            [placeholder]="'CREATE_USER.PASSWORD' | translate"
            autoComplete="new-password"
            [ngClass]="{
              'is-invalid': createUserForm.controls['password'].invalid,
              'is-valid': createUserForm.controls['password'].valid
            }"
          />
          <ng-container
            [ngTemplateOutlet]="formError"
            [ngTemplateOutletContext]="{
              validation: 'required',
              message: 'MANAGE_USERS.PASSWORD_REQUIRED' | translate,
              control: createUserForm.controls['password']
            }"
          >
          </ng-container>
          <ng-container
            [ngTemplateOutlet]="formError"
            [ngTemplateOutletContext]="{
              validation: 'minlength',
              message: 'MANAGE_USERS.PASSWORD_MIN' | translate,
              control: createUserForm.controls['password']
            }"
          >
          </ng-container>
          <ng-container
            [ngTemplateOutlet]="formError"
            [ngTemplateOutletContext]="{
              validation: 'maxLength',
              message: 'MANAGE_USERS.PASSWORD_MAX' | translate,
              control: createUserForm.controls['password']
            }"
          >
          </ng-container>
        </div>
      </div>

      <div class="mt-5 border-t-1 border-gray-200 flex justify-end py-6">
        <button
          pButton
          [severity]="'success'"
          type="submit"
          [size]="'large'"
          class="!text-white !font-semibold"
          [disabled]="createUserForm.invalid || loadingData"
        >
          @if(!loadingData){ {{ "CREATE_USER.CREATE_USER" | translate }} }@else{
          <span class="indicator-progress" [style.display]="'block'">
            {{ "CREATE_USER.PLEASE_WAIT" | translate }}
            <span class="spinner-border spinner-border-sm align-middle"></span>
          </span>
          }
        </button>
      </div>
    </form>
    <ng-template
      #formError
      let-control="control"
      let-message="message"
      let-validation="validation"
    >
      @if( control.hasError(validation) && (control.dirty || control.touched)){

      <div class="">
        <span role="alert">
          {{ message }}
        </span>
      </div>

      }
    </ng-template>
  </div>
</div>
}

<p-toast baseZIndex="100000" position="center"></p-toast>
